import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import Renderers from '~common/lib/renderers';
import {FormControl, InputLabel } from '@mui/material';
import CronSelectView from '~common/components/cron-select-view';


const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 400
    },
    formDefField: {
        width: "100%",
    },
    displayText: {
        marginTop: 16,
        fontSize: "1.05rem",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
 
}

type State = {

};


class CronScheduleView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {
        
        }
      }

      static register = () => {

        if(!Renderers.find("cronScheduleView")){

          Renderers.register("cronScheduleView", withStyles(styles)(CronScheduleView))
        }
      }

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        
        return (

            <FormControl className={classes.formDefClass} style={{}}>
                <InputLabel style={{}} shrink>
                    {this.props.fieldDefinition.title}
                </InputLabel>
              <div className={classes.displayText}>
                <CronSelectView
                    readOnly
                    classes={{}}
                    cron={this.props.value}
                    onCronChange={undefined}
                />
              </div>
            </FormControl>

           
        )
    }
}

export default withStyles(styles)(CronScheduleView);